import React from "react";
import {
  CART_STACK_PATHS_CONTAIN_CHECK,
  PT_CART,
} from "../../routes/stack/paths/pt-cart";
import {
  PROFILE_STACK_PATHS_CONTAIN_CHECK,
  PT_PROFILE,
} from "../../routes/stack/paths/pt-profile";
import { Colors } from "../../util/colors";
import {
  HOME_STACK_PATHS_CONTAIN_CHECK,
  PT_HOME,
  PT_LAND,
} from "../../routes/stack/paths/pt-home";
import { isMobile } from "react-device-detect";
import {
  CSP,
  ENCRYPT_STORAGE,
  WebBottom,
  WebLeft,
  WebWidth,
} from "../../config/config";
import "../../styles/css/bottom-footer.css";
import { GET_CART_COUNT } from "../../functions/funtion";
import {
  ORDER_STACK_PATHS_CONTAIN_CHECK,
  PT_ORDERS,
} from "../../routes/stack/paths/pt-orders";
import {
  GROCERY_STACK_PATHS_CONTAIN_CHECK,
  PT_GROCERY_CATEGORY,
} from "../../routes/stack/paths/pt-grocery";
import { dto_Customer } from "../../classes/dto-customer";
import { ENTRY_MODE } from "../../database/store-names";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultColor: "#969493",
      activeIndex: 1,
    };
  }

  componentDidMount() {  
    if (HOME_STACK_PATHS_CONTAIN_CHECK(window.location.pathname)) {
      this.setState({ activeIndex: parseInt(1) });
    } else if (CART_STACK_PATHS_CONTAIN_CHECK(window.location.pathname)) {
      this.setState({ activeIndex: parseInt(2) });
    } else if (ORDER_STACK_PATHS_CONTAIN_CHECK(window.location.pathname)) {
      this.setState({ activeIndex: parseInt(3) });
    } else if (PROFILE_STACK_PATHS_CONTAIN_CHECK(window.location.pathname)) {
      this.setState({ activeIndex: parseInt(4) });
    } else if (GROCERY_STACK_PATHS_CONTAIN_CHECK(window.location.pathname)) {
      this.setState({ activeIndex: parseInt(5) });
    } else {
      this.setState({ activeIndex: parseInt(1) });
    }
    GET_CART_COUNT();
  }
  
  render() {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const isPosOrQr = entryMode === "QR";
    const hideFooterForAnonymousQr =
      entryMode === "QR" &&
      (dto_Customer.CSID === 0 || dto_Customer.CSID === undefined);
    const hideProfileForDtPosQr = CSP === "DT" && isPosOrQr;
    const itemBaseStyle = {
      flex: 1,
      backgroundColor: "white",
      height: 50,
      padding: 10,
    };
    if (hideFooterForAnonymousQr) {
      return null;
    }
    return (
      <div
        style={{
          position: "fixed",
          left: isMobile ? 0 : WebLeft,
          width: isMobile ? "100%" : WebWidth,
          bottom: isMobile ? 0 : WebBottom,
          backgroundColor: "white",
          zIndex: 1500,
          height: 50,
          boxShadow: "0 0px 8px 0 rgba(0,0,0,0.2)",
        }}
      >
        <div style={{ display: "flex" }}>
          {/* HOME */}
          <div
            // className="fixedFooterContent"
            style={{
              ...itemBaseStyle,
              display: isPosOrQr ? "none" : "block",
            }}
          >
            <div
              style={{
                textAlign: "center",
                color:
                  this.state.activeIndex === 1
                    ? Colors.DarkGreyScale
                    : this.state.defaultColor,
                cursor: "pointer",
              }}
              onClick={() => {
                const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
                if (entryMode === "QR") {
                  return;
                }
                this.setState({ activeIndex: 1 });
                if (CSP === "AV") {
                  this.props.navigate(PT_LAND);
                  // this.props.navigate(PT_TYPE_LAND);
                } else {
                  this.props.navigate(PT_HOME);
                }
              }}
            >
              {this.state.activeIndex === 1 ? (
                <i
                  className="bi bi-house-fill"
                  aria-hidden="true"
                  style={{ fontSize: 20 }}
                />
              ) : (
                <i
                  className="bi bi-house"
                  aria-hidden="true"
                  style={{ fontSize: 20 }}
                />
              )}
              <p style={{ margin: 0, fontSize: 11 }}>{"Home"}</p>
            </div>
          </div>

          {/* GROCERY */}
          <div
            style={{
              ...itemBaseStyle,
              display: CSP === "AV" ? "block" : "none",
            }}
            onClick={() => {
              this.setState({ activeIndex: 5 });
              this.props.navigate(PT_GROCERY_CATEGORY);
            }}
          >
            <div
              style={{
                textAlign: "center",
                color:
                  this.state.activeIndex === 5
                    ? Colors.DarkGreyScale
                    : this.state.defaultColor,
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({ activeIndex: 5 });
                this.props.navigate(PT_ORDERS);
              }}
            >
              {this.state.activeIndex === 5 ? (
                <i
                  className="bi bi-basket-fill"
                  aria-hidden="true"
                  style={{ fontSize: 22 }}
                />
              ) : (
                <i
                  className="bi bi-basket"
                  aria-hidden="true"
                  style={{ fontSize: 22 }}
                />
              )}

              <p style={{ margin: 0, fontSize: 11 }}>Grocery</p>
            </div>
          </div>

          {/* CART */}
          <div
            style={{
              ...itemBaseStyle,
            }}
            onClick={() => {
              this.setState({ activeIndex: 2 });
              this.props.navigate(PT_CART);
            }}
          >
            <div
              style={{
                textAlign: "center",
                color:
                  this.state.activeIndex === 2
                    ? Colors.DarkGreyScale
                    : this.state.defaultColor,
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({ activeIndex: 2 });
                this.props.navigate(PT_CART);
              }}
            >
              {this.state.activeIndex === 2 ? (
                <i
                  className="bi bi-cart-fill"
                  aria-hidden="true"
                  style={{ fontSize: 20 }}
                />
              ) : (
                <i
                  className="bi bi-cart"
                  aria-hidden="true"
                  style={{ fontSize: 20 }}
                />
              )}
              <span id="lblCartCount"> 5 </span>

              <p style={{ margin: 0, fontSize: 11 }}>{"Cart"}</p>
            </div>
          </div>

          {/* ORDERS */}
          <div
            style={{
              ...itemBaseStyle,
            }}
            onClick={() => {
              this.setState({ activeIndex: 3 });
              this.props.navigate(PT_ORDERS);
            }}
          >
            <div
              style={{
                textAlign: "center",
                color:
                  this.state.activeIndex === 3
                    ? Colors.DarkGreyScale
                    : this.state.defaultColor,
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({ activeIndex: 3 });
                this.props.navigate(PT_ORDERS);
              }}
            >
              {this.state.activeIndex === 3 ? (
                <i
                  className="bi bi-menu-button-wide-fill"
                  aria-hidden="true"
                  style={{ fontSize: 20 }}
                />
              ) : (
                <i
                  className="bi bi-menu-button-wide"
                  aria-hidden="true"
                  style={{ fontSize: 20 }}
                />
              )}
              <p style={{ margin: 0, fontSize: 11 }}> {"My Orders"}</p>
            </div>
          </div>

          {/* PROFILE */}
          <div
            style={{
              ...itemBaseStyle,
              display: hideProfileForDtPosQr ? "none" : "block",
            }}
            onClick={() => {
              this.setState({ activeIndex: 4 });
              this.props.navigate(PT_PROFILE);
            }}
          >
            <div
              style={{
                textAlign: "center",
                color:
                  this.state.activeIndex === 4
                    ? Colors.DarkGreyScale
                    : this.state.defaultColor,
                cursor: "pointer",
              }}
              onClick={() => {
                this.setState({ activeIndex: 3 });
                this.props.navigate(PT_ORDERS);
              }}
            >
              {this.state.activeIndex === 4 ? (
                <i
                  className="bi bi-person-fill"
                  aria-hidden="true"
                  style={{ fontSize: 22 }}
                />
              ) : (
                <i
                  className="bi bi-person"
                  aria-hidden="true"
                  style={{ fontSize: 22 }}
                />
              )}

              <p style={{ margin: 0, fontSize: 11 }}>{"Profile"}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
